import { inject, Injectable } from '@angular/core';
import { PreselectionType } from '../../shared/enums/preselection-type';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PreselectionService {
  private router = inject(Router);

  private id: string | null = null;
  private searchTerm = '';
  private preselectionType = PreselectionType.Unknown;

  public configureAndChangeRoute(id: string, searchTerm: string, preselectionType: PreselectionType): void {
    this.id = id;
    this.searchTerm = searchTerm;
    this.preselectionType = preselectionType;

    switch (preselectionType) {
      case PreselectionType.Dtc:
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dtc/overview/']);
        });
        break;
      case PreselectionType.ErrorMessage:
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/error-message/overview/']);
        });
        break;
      case PreselectionType.SwPartNumber:
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/sw-part-number/overview/']);
        });
        break;
      default:
        throw new Error('Unhandled preselectionType detected');
    }
  }

  public getIdAndClear(preselectionType: PreselectionType): string | null {
    if (preselectionType != this.preselectionType) {
      return null;
    }

    const result = this.id;
    this.id = null;
    return result;
  }

  public getSearchTermAndClear(preselectionType: PreselectionType): string {
    if (preselectionType != this.preselectionType) {
      return '';
    }

    const result = this.searchTerm;
    this.searchTerm = '';
    return result;
  }
}
